const loadImageBlueimp = require('blueimp-load-image');
import { mmToPixels, mmToInches, pixelsToMm, inchesToMm } from '@/utils/unitsUtils';
import { inferFormatFromImage } from '@/utils/imageUtils';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('PageDimensionsModalCtrl', pageDimensionsModalCtrl);

    function pageDimensionsModalCtrl(
        $scope,
        $mdDialog,
        $timeout,
        blockUI,
        VectorUtilService,
        ImageUtilService,
        mode,
        initialWidth,
        initialHeight,
        ProductService,
        title,
        exportPPI,
        initialUnit
    ) {
        $scope.pageEpsCreate = mode === 'create-page-eps';
        if (title) {
            $scope.title = title;
        } else {
            $scope.title = mode === 'create' || mode === 'create-page-eps' ? 'New File' : 'Edit Dimensions';
        }
        $scope.submitButtonText = mode === 'create' || mode === 'create-page-eps' ? 'Create page' : 'Edit page';
        $scope.showProductName = mode === 'create';
        $scope.showBaseUpload = mode === 'create' || mode === 'create-page-eps';
        $scope.uploadingBaseFile = false;
        $scope.DPI = exportPPI || 300;
        $scope.errorUploadingBaseFile = false;
        $scope.askForImageDpi = false;
        $scope.unit = initialUnit || 'mm';

        $scope.maxWidth = 20000;
        $scope.maxHeight = 20000;

        $scope.childTemplateProduct = ProductService.getChildTemplateProduct();
        $scope.isChildTemplateProduct = $scope.childTemplateProduct && $scope.childTemplateProduct.parentId;

        $scope.$watch('unit', (unit, previousUnit) => {
            if (initialUnit != 'mm' && unit == previousUnit) {
                previousUnit = 'mm';
            }

            convertUnits(unit, previousUnit);

            switch (unit) {
                case 'mm':
                    $scope.maxWidth = 20000;
                    $scope.maxHeight = 20000;
                    break;

                case 'inch':
                    $scope.maxWidth = 800;
                    $scope.maxHeight = 800;
                    break;

                case 'px':
                    $scope.maxWidth = 16000;
                    $scope.maxHeight = 16000;
                    break;
            }
        });

        let orientatedBaseImage = null;
        let baseImageFile = null;

        $scope.page = {
            pageWidthDim: initialWidth,
            pageHeightDim: initialHeight,
            productName: 'Sample Template'
        };

        const convertPageUnitsToMm = (page, unit, dpi) => {
            let w = page.pageWidthDim;
            let h = page.pageHeightDim;

            switch (unit) {
                case 'inch':
                    w = inchesToMm(w);
                    h = inchesToMm(h);
                    break;

                case 'px':
                    w = pixelsToMm(w, dpi);
                    h = pixelsToMm(h, dpi);
                    break;
            }

            return {
                ...page,
                pageWidthDim: w,
                pageHeightDim: h,
                pageDPI: dpi,
                submittedData: {
                    width: page.pageWidthDim,
                    height: page.pageHeightDim,
                    unit
                }
            };
        };

        const convertUnits = (unit, previousUnit) => {
            if (unit === 'mm') {
                if (previousUnit === 'px') {
                    $scope.page.pageWidthDim = pixelsToMm($scope.page.pageWidthDim, $scope.DPI);
                    $scope.page.pageHeightDim = pixelsToMm($scope.page.pageHeightDim, $scope.DPI);
                } else if (previousUnit === 'inch') {
                    $scope.page.pageWidthDim = inchesToMm($scope.page.pageWidthDim, $scope.DPI);
                    $scope.page.pageHeightDim = inchesToMm($scope.page.pageHeightDim, $scope.DPI);
                }
                return;
            }

            if (unit === 'px') {
                if (previousUnit === 'mm') {
                    $scope.page.pageWidthDim = mmToPixels($scope.page.pageWidthDim, $scope.DPI);
                    $scope.page.pageHeightDim = mmToPixels($scope.page.pageHeightDim, $scope.DPI);
                } else if (previousUnit === 'inch') {
                    $scope.page.pageWidthDim = mmToPixels(inchesToMm($scope.page.pageWidthDim, $scope.DPI), $scope.DPI);
                    $scope.page.pageHeightDim = mmToPixels(
                        inchesToMm($scope.page.pageHeightDim, $scope.DPI),
                        $scope.DPI
                    );
                }
                return;
            }

            if (unit === 'inch') {
                if (previousUnit === 'px') {
                    $scope.page.pageWidthDim = mmToInches(pixelsToMm($scope.page.pageWidthDim, $scope.DPI), $scope.DPI);
                    $scope.page.pageHeightDim = mmToInches(
                        pixelsToMm($scope.page.pageHeightDim, $scope.DPI),
                        $scope.DPI
                    );
                } else if (previousUnit === 'mm') {
                    $scope.page.pageWidthDim = mmToInches($scope.page.pageWidthDim, $scope.DPI);
                    $scope.page.pageHeightDim = mmToInches($scope.page.pageHeightDim, $scope.DPI);
                }
            }
        };

        $scope.onSubmit = function () {
            $mdDialog.hide({
                page: convertPageUnitsToMm($scope.page, $scope.unit, $scope.DPI)
            });
            $scope.$applyAsync();
        };

        $scope.multiEpsAlertAccept = function () {
            window.localStorage.setItem('multiEpsAlert', true);
            $mdDialog.hide();
        };

        $scope.multiEpsAlertClose = function () {
            $mdDialog.hide();
        };

        $scope.onDpiSubmit = function () {
            // Now that we have the image DPI process it
            $scope.DPI = $scope.DPI || 300;
            processBaseImage(orientatedBaseImage, baseImageFile);
        };

        $scope.uploadBaseFile = function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                if (files[0].name.split('.').pop() == 'eps') {
                    $scope.uploadBaseEPS(files);
                } else {
                    $scope.uploadBaseImage(files);
                }
            }
        };

        const processBaseImage = function (img, file) {
            const imageFormat = inferFormatFromImage(file);
            ImageUtilService.imageToBase64(img, imageFormat).then(function (base64) {
                const baseImagePath = base64;
                const baseImageToUpload = file;

                $scope.page.pageWidthDim = pixelsToMm(img.width, $scope.DPI);
                $scope.page.pageHeightDim = pixelsToMm(img.height, $scope.DPI);

                $mdDialog.hide({
                    page: convertPageUnitsToMm($scope.page, $scope.unit, $scope.DPI),
                    image: {
                        baseImageToUpload: baseImageToUpload,
                        baseImagePath: baseImagePath,
                        DPI: $scope.DPI
                    }
                });

                $timeout(function () {
                    $scope.$apply();
                    $('#baseFileHiddenUpload')[0].value = null;
                });
            });
        };

        /**
         * Upload a base image to use as the production file background and use its dimensions as the production file dimensions.
         * @param files uploaded image files
         */
        $scope.uploadBaseImage = function (files) {
            if (files && files[0]) {
                // Load the image file and read the EXIF metadata
                loadImageBlueimp(
                    files[0],
                    function (img, data) {
                        // Check if we have the resolution metadata, if not, ask the user for the desired one
                        if (data.exif && data.exif.get('XResolution')) {
                            // Assume X and Y resolution are the same
                            $scope.DPI = data.exif.get('XResolution');
                            processBaseImage(img, files[0]);
                        } else {
                            // Ask the user to enter the image DPI
                            $scope.askForImageDpi = true;
                            baseImageFile = files[0];
                            orientatedBaseImage = img;
                            $timeout(() => $scope.$apply());
                        }
                    },
                    { orientation: true, meta: true }
                );
            } else {
                throw new Error('No image files, how did this happen?');
            }
        };

        /**
         * Upload and set the given EPS file as canvas background
         * @param files array of files with the first one being the EPS file we should use to replace the canvas background
         */
        $scope.uploadBaseEPS = function (files) {
            if (files && files[0]) {
                blockUI.start('Uploading EPS');
                $timeout(function () {
                    $scope.$apply();
                });

                VectorUtilService.uploadVectorToS3(files[0], 'base', true, false, function (type, progress) {
                    if (type === 'upload') {
                        blockUI.message(`Uploading EPS ${parseInt(progress)}%`);
                        $timeout(() => {
                            $scope.$apply();
                        });
                    } else {
                        blockUI.message('Processing');
                    }
                })
                    .then((data) => {
                        const baseEpsPath = data.EPS;
                        const baseImagePath = data.SVG;

                        $scope.page.pageWidthDim = data.Width;
                        $scope.page.pageHeightDim = data.Height;

                        $mdDialog.hide({
                            page: convertPageUnitsToMm($scope.page, $scope.unit, $scope.DPI),
                            eps: {
                                baseEpsPath: baseEpsPath,
                                baseImagePath: baseImagePath
                            }
                        });

                        $timeout(function () {
                            $scope.$apply();
                            blockUI.reset();
                            $('#baseFileHiddenUpload')[0].value = null;
                        });
                    })
                    .catch((err) => {
                        window.rumReportError(err);

                        blockUI.reset();
                        if ($('#baseFileHiddenUpload')[0]) {
                            $('#baseFileHiddenUpload')[0].value = null;
                        }

                        $scope.errorUploadingBaseFile = true;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    });
            }
        };
    }
})();
